module.exports = __webpack_public_path__ + "static/media/icPromptCompleted.99664736.svg";